// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The inspector panel token.
 */
export const IInspector = new Token('@jupyterlab/inspector:IInspector', `A service for adding contextual help to widgets (visible using "Show Contextual Help" from the Help menu).
  Use this to hook into the contextual help system in your extension.`);
//# sourceMappingURL=tokens.js.map